<template>
  <el-card>
    <el-row type="flex" justify="center">
      <el-col :span="22">
        <div class="Amount_box" v-if="![0, 4].includes(userType)"> 
          <div >
            {{$t('welcome.label.MerchantBalance')}} : <span>{{ allAmount | toThousands }}</span>
          </div>
          <div>
            {{$t('welcome.label.usdtWalletBalance')}} : <span>{{ usdtWalletBalance | toThousands }}</span>
          </div>
        </div>     
        <el-row
          v-for="(table, index) in infoDetailData"
          :data="table"
          :key="index"
          style="margin: 66px 0 0 0">
          <div class="header">
            
            <el-divider></el-divider>
            <p>{{ $t(`welcome.label.${index}`) }}</p>
          </div>
          <el-table stripe :data="table" v-if="table.length">
            <el-table-column
              v-for="item in Object.keys(table[0]).filter((r) => tablehideKeys.indexOf(r) === -1)"
              :key="item.id"
              :label="$t(`welcome.label.${item}`)"
            >
              <!-- <template slot="header">
                {{ $t(`welcome.label.${item}`) }}
              </template> -->
              <template slot-scope="{ row }">
                <span v-if="['amountOfFail', 'amountOfProfit', 'amountOfSuccess', 'amountOfTotal'].indexOf(item) > -1">
                  {{ row[item] | toThousands }}
                </span>
                <span v-else>
                  {{ row[item] }}
                </span>
              </template>
            </el-table-column>
          </el-table>
<!--          <el-table :data="table" v-if="table.length">-->
<!--            <el-table-column-->
<!--              v-for="item in Object.keys(table[0]).filter((r) => tablehideKeys.indexOf(r) === -1)"-->
<!--              :key="item.id"-->
<!--              :label="$t(`welcome.label.${item}`)"-->
<!--              >-->
<!--              <template slot-scope="{ row }">-->
<!--                <span v-if="moneystr.indexOf(item) > -1">-->
<!--                  {{ row[item] | toThousands }}-->
<!--                </span>-->
<!--                <span v-else>-->
<!--                  {{ row[item] }}-->
<!--                </span>-->
<!--              </template>-->
<!--            </el-table-column>-->
<!--          </el-table>-->
        </el-row>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center" style="margin: 66px 0 0 0">
      <el-col :span="22">
        <div class="header">
          <p>{{ $t(`welcome.label.focusinfo`) }}</p>
        </div>
        <el-table :data="infoTableData" border header-align="right">
          <el-table-column>
            <template slot-scope="{ row }">
             {{ $t(`welcome.label.${row.fieldName}`) }}
            </template>
          </el-table-column>
          <el-table-column v-for="item in totalDataKeys" :key="item">
            <template slot="header" slot-scope="{ row }">
              {{ row }}
              {{ $t(`welcome.label.${item}`) }}
            </template>
            <template slot-scope="{ row }">
              <span v-if="moneystr.indexOf(row.fieldName) > -1">
                {{ row[item] | toThousands }}
              </span>
              <span v-else>
                {{ row[item] }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import { getReport } from '@/api/index';
import merchantdepositApi from '@/api/merchantdeposit';
import {mapState} from 'vuex'
export default {
  // @NOTE 关闭缓存
  // name: 'Workplace',
  data() {
    return {
      totalData: {},
      allAmount:0,
      usdtWalletBalance:0,//当前登录商户usdt余额
    };
  },
  created() {
    this.init();
  },
  computed: {
    infoData() {
      return this.totalDataKeys
        .map((key) => this.totalData[key])
        .sort((a, b) => Object.keys(a).length - Object.keys(b).length);
    },
    infoDetailData() {
      if (!Object.keys(this.totalData).length)
        return { todayDetails: [], yesterdayDetails: [] };
      return this.detailsKeys.reduce((acc, curr) => {
        acc[curr] = this.totalData[curr];
        return acc;
      }, {});
    },
    infoTableData() {
      if (!Object.keys(this.totalData).length) return [];
      return Object.keys(this.infoData[0])
        .filter((r) => this.hideKeys.indexOf(r) === -1)
        .reduce((acc, curr, index) => {
          acc[index] = {
            fieldName: curr,
            ...this.totalDataKeys.reduce((acc1, curr1) => {
              acc1[curr1] = this.totalData[curr1][curr];
              return acc1;
            }, {})
          };
          return acc;
        }, [])
        .sort((a, b) => {
          if (
            a.fieldName.indexOf('payout') === -1 &&
            b.fieldName.indexOf('payout') === -1 &&
            a.fieldName.indexOf('payment') === -1 &&
            b.fieldName.indexOf('payment') === -1
          ) {
            return 0;
          }
          if (
            (a.fieldName.indexOf('payout') === 0 && b.fieldName.indexOf('payment') === 0) ||
            (a.fieldName.indexOf('paymentNumber') === 0 &&
              b.fieldName.indexOf('paymentAmount') === 0) ||
            (a.fieldName.indexOf('payoutNumber') === 0 &&
              b.fieldName.indexOf('payoutAmount') === 0) ||
            (a.fieldName.indexOf('payment') === 0 && b.fieldName.indexOf('payout') === 0)
          ) {
            return -1;
          }
          return 1;
        });
    },
      ...mapState({
      userType: ({user}) => user.info.userType,
      userName: ({user}) => user.info.userName
    })
  },
  mounted() {
    this.getReport();
     if (![0, 4].includes(this.userType)) {
      this.getSummary();
    }
  },
  methods: {
    init() {
      /* --------------------------------- 需要隐藏的字段 -------------------------------- */
      this.hideKeys = [
        'id',
        'owner',
        'updateTime',
        'dateType',
        'userType',
        'paymentSuccessRate',
        'paymentAmountOfProfit',
        'payoutAmountOfProfit',
        'payoutSuccessRate',
        'amountOfFail',
        'amountOfSuccess',
        'amountOfTotal',
        'channel',
        'numberOfFail',
        'numberOfSuccess',
        'numberOfTotal',
        'successRate'
      ];
      this.tablehideKeys = [
        'id',
        'owner',
        'updateTime',
        'dateType',
        'userType',
        'paymentSuccessRate',
        'paymentAmountOfProfit',
        'payoutAmountOfProfit',
        'payoutSuccessRate',
        'paymentNumberOfSuccess',
        'payoutNumberOfSuccess',
        'paymentNumberOfFail',
        'payOutNumberOfFail',
        'paymentNumberOfTotal',
        'payoutNumberOfTotal',
        'paymentAmountOfSuccess',
        'payoutAmountOfSuccess',
        'paymentAmountOfFail',
        'payoutAmountOfFail',
        'paymentAmountOfTotal',
        'payoutAmountOfTotal'
      ];
      /* ------------------------------- 需要格式化的金额字段 ------------------------------- */
      this.moneystr = [
        'amountOfFail',
        'amountOfProfit',
        'amountOfSuccess',
        'amountOfTotal',
        'paymentAmountOfSuccess',
        'payoutAmountOfSuccess',
        'paymentAmountOfFail',
        'payoutAmountOfFail',
        'paymentAmountOfTotal',
        'payoutAmountOfTotal'
      ];
      this.detailsKeys = ['todayDetails', 'yesterdayDetails'];//'toMonthDetails',
      this.totalDataKeys = ['today', 'yesterday', 'toMonth'];
    },
    async getReport() {
      const { data } = await getReport();
      if (data) {
        if (data.code === 200) {
          this.totalData = data.data;
        } else {
          this.$message.error(data.msg);
        }
      }
    },

    async getSummary() {
      const params = {
        merchantNo: this.userName
      };
      const { data } = await merchantdepositApi.getSummary(params);
      if (data) {
        if (data.code === 200) {
          this.allAmount = data.data.allWalletBalance;
          this.usdtWalletBalance = data.data.usdtWalletBalance;
        } 
      }
    },
  }
};
</script>

<style scoped lang="scss">
.Amount_box {
  transform: translateY(50px);
  display: flex;
  align-items: center;
  div {
    margin-right:  20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/index.vue